import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Register.css"; // Retained for styling
import LoginForm from "../components/LoginForm.jsx"; // New import
import Navbar from "../components/Navbar";

function Login() {
  return (
    <div className="agent-page-premium">
      <Navbar />
      
      <ToastContainer
        position="top-right"
        autoClose={5000}
        theme="colored"
      />

      <div className="premium-hero-mini">
        <div className="hero-content">
          <h1>Welcome Back</h1>
          <p>Your journey continues here. Sign in to access your travel world.</p>
        </div>
      </div>

      <div className="premium-container-wide">
        <div className="premium-glass-card" style={{ maxWidth: '600px', margin: '-60px auto 0' }}>
          <div className="register-header-premium">
            <h2 style={{ fontSize: '24px', fontWeight: '800', color: '#1e293b' }}>Sign In</h2>
          </div>

          <LoginForm />

          <div className="register-footer-premium">
            <p className="signin-text">
              Don't have an account? <a href="/register">Create Account</a>
            </p>
            <p className="signin-text" style={{ marginTop: "10px", fontSize: "13px", color: "#64748b" }}>
              Are you an administrator? <a href="/admin/login" style={{ color: "#3b82f6", fontWeight: "600" }}>Admin Sign In →</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}


export default Login;
